import { OverlayTrigger, Tooltip } from "react-bootstrap";
import { TimeLineEventOverlayButton } from "./timelineevent.styled.jsx";
import { TimelineEventDecline } from "../icons.jsx";
import { useTranslation } from "react-i18next";

export const DeclineButton = ({ declineEvent }) => {
  const { t } = useTranslation();

  return (
    <OverlayTrigger
      placement="top-end"
      overlay={
        <Tooltip id="button-tooltip-2" style={{ position: "fixed" }}>
          {t("Decline", "Hylkää")}
        </Tooltip>
      }
    >
      <TimeLineEventOverlayButton $action="decline" onClick={declineEvent}>
        <TimelineEventDecline />
      </TimeLineEventOverlayButton>
    </OverlayTrigger>
  );
};